import { z } from 'zod';
import i18n from 'i18next';

/** Client-side minimum; the server enforces the full policy (history, complexity) and answers 422. */
export const PASSWORD_MIN = 12; // FR-IAM-02 (api/src/kernel/auth/passwords.ts)

export function passwordField() {
  return z.string().min(PASSWORD_MIN, { message: i18n.t('common:auth.passwordTooShort', { min: PASSWORD_MIN }) });
}

/** `{ password, confirm }` with a match check. */
export function newPasswordSchema() {
  return z
    .object({ password: passwordField(), confirm: z.string() })
    .refine((v) => v.password === v.confirm, { path: ['confirm'], message: i18n.t('common:auth.passwordMismatch') });
}

export type NewPasswordValues = z.infer<ReturnType<typeof newPasswordSchema>>;
